module.exports = __webpack_public_path__ + "static/media/SummaryCh9_A01378565.ddcf2149.pdf";